import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import {
  DESKTOP_REQUIRED_DESTINATION_QUERY_PARAM,
  DesktopRequiredDestinations,
} from '../desktop-required/desktop-required-destination';
import { BreakpointService } from '../services/breakpoint.service';
import { TripAccessService } from '../services/trip-access/trip-access.service';
import { TripService } from '../services/trip.service';

/**
 * Group management: desktop-width only, then GL/lead or BG admin only.
 * Parents, finance-only, and plain participants are sent to dashboard.
 */
export const groupManagementGuard: CanActivateFn = () => {
  const breakpointService = inject(BreakpointService);
  const router = inject(Router);
  const tripService = inject(TripService);
  const tripAccess = inject(TripAccessService);

  if (breakpointService.isMobile()) {
    return router.createUrlTree(['/desktop-required'], {
      queryParams: {
        [DESKTOP_REQUIRED_DESTINATION_QUERY_PARAM]:
          DesktopRequiredDestinations.GroupManagement,
      },
    });
  }

  if (!tripService.currentTripLoaded()) {
    return true;
  }

  const trip = tripService.currentTrip.value();
  if (!tripAccess.context(trip)?.canAccessGroupManagement) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
